import { FC } from 'react';
import { ParagraphImageFragment } from '../../../generated/types';
import { Box } from '@chakra-ui/react';
import { Image as ImageComponent } from '../../Common/Image';

interface ImageProps {
  data: ParagraphImageFragment;
}

export const Image: FC<ImageProps> = ({ data }) => {
  if (!data.image) return null;

  let imageStyle = data.image.landscape;

  if (data.format === 'portrait') imageStyle = data.image.portrait;
  if (data.format === 'original') imageStyle = data.image.original;

  return (
    <Box className={data.__typename}>
      <ImageComponent
        borderRadius="sm"
        image={data.image}
        imageStyle={imageStyle}
        description={data.description}
      />
    </Box>
  );
};
